import React, { useState } from 'react'
import Header from '../Components/Header'
import { Alert, Container, IconButton } from '@mui/material'
import image from "../Files/Titles/articles.png"
import Footer from '../Components/Footer'
import { Mic, SendRounded, VoiceOverOff, RecordVoiceOver, AutoAwesome } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { Form } from 'antd'
import TopHeader from '../Components/TopHeader'
import TitrePage from './TitrePage'
import { generateText } from '../Services/api/GenerationTexte'

import 'react-chat-elements/dist/main.css';
import { MessageList } from 'react-chat-elements'
import datas from "../Data/.json"
import logoWhite from '../Files/IBG Logo single  white.svg'

import TypingText from '../Components/TypingText'
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import LanguageDetect from "languagedetect"
import avatarMoi from "../Files/avatarMoi.svg"
import avatarIa from "../Files/avatarIa.svg"
import { Riple } from 'react-loading-indicators'

const API_KEY: any = process.env.REACT_APP_GEMINI_API_KEY;

interface Props { }

function FocusIA(props: Props) {
    const { t } = useTranslation();

    const [loading, setLoading] = useState(false);

    const [lecture, setLecture] = useState(false)
    const [alertError, setAlertError] = useState(false)
    const [alertErrorSpeech, setAlertErrorSpeech] = useState(false)


    const [messages, setMessages] = useState<any>([]);
    const [userMessage, setUserMessage] = useState("");

    // if (pageLoaded) {
    //     setPageLoaded(false)
    //     try {
    //         var data = JSON.parse(localStorage.getItem(datas.chat) + "") as []
    //         // var tmp = [];

    //         // for (let index = 0; index < data.length; index++) {
    //         //     const element = data[index] as any;
    //         //     tmp.push({
    //         //         key:index,
    //         //         ref: React.createRef(),
    //         //         ...element
    //         //     })
    //         // }
    //         // alert(JSON.stringify(tmp))

    //         // if (data) {
    //         //     setMessages(data)
    //         // }
    //     } catch (error) {
    //         alert(error)
    //     }
    // }
    const handleSendMessage = async () => {
        if (userMessage.trim() === "") return;

        const newMessage = {
            // sender: "Moi",
            position: 'right',
            type: 'text',
            text: <div className="ibg-bubble ibg-bubble--user">{userMessage}</div>,
            date: new Date(),
            avatar: avatarMoi,
        };
        // alert(JSON.stringify([...messages, newMessage]))
        localStorage.setItem(datas.chat, JSON.stringify([...messages, newMessage]))
        setMessages([...messages, newMessage]);
        setUserMessage("");
        setLoading(true);

        try {
            const response = await generateText(userMessage, API_KEY);
            const botMessage = {
                position: 'left',
                type: 'text',
                text: <TypingText text={response} />,
                date: new Date(),
                avatar: avatarIa,
            };
            setMessages((prevMessages: any) => [...prevMessages, botMessage]);
        } catch (error) {
            const errorMessage = {
                position: 'center',
                type: 'text',
                text: <span className="ibg-chat-error">Erreur lors de la génération.</span>,
                date: new Date(),
            };
            setMessages((prevMessages: any) => [...prevMessages, errorMessage]);
        } finally {
            setLoading(false);
        }
    };

    const {
        transcript,
        listening,
        browserSupportsSpeechRecognition
    } = useSpeechRecognition();

    // if (!browserSupportsSpeechRecognition) {
    //     return <span>Browser doesn't support speech recognition.</span>;
    // }

    setTimeout(() => {
        if (listening) {
            setUserMessage(transcript)
        }
    }, listening ? 1 : 0)

    function handleSpeechMessage() {
        try {
            setLecture(true)
            const msg = new SpeechSynthesisUtterance()
            msg.text = messages[messages.length - 1].text.props.text.replaceAll("*", "")

            // Détection automatatique de lanque
            const lngDetector = new LanguageDetect();
            msg.lang = (lngDetector.detect(msg.text)[0][0] === "french" ? "fr-fr" : "en-en")

            msg.onend = () => setLecture(false)
            window.speechSynthesis.speak(msg)
        } catch (error) {
            setAlertErrorSpeech(true)
            setTimeout(() => {
                setAlertErrorSpeech(false)
            }, 3000);
        }

        // OR
        // const lngDetector = new (require('languagedetect'));

    }

    const suggestions = [t("Pages.suggestion1"), t("Pages.suggestion2"), t("Pages.suggestion3")]

    return (
        <div className="ibg-page">
            <TopHeader />
            <Header />
            <TitrePage hiddeTitle image={image} titre={"titrePage.FocusIA.titre"} lien='focusia' pageDescription={'titrePage.FocusIA.description'} keyWords={'titrePage.FocusIA.keywords'} />
            <section className="ibg-assistant">
                <Container maxWidth="md">
                    <div className="ibg-assistant__card">
                        <div className="ibg-chat__head">
                            <span className="ibg-chat__avatar"><img src={logoWhite} alt="" /></span>
                            <div>
                                <strong>Focus IA</strong>
                                <span className="ibg-chat__status">{t("Home.online")}</span>
                            </div>
                        </div>

                        <div className="ibg-assistant__messages">
                            {messages.length > 0 ? "" :
                                <div className="ibg-assistant__empty">
                                    <span className="ibg-assistant__mark"><AutoAwesome /></span>
                                    <h1 className="ibg-h2">{t("startChat")}</h1>
                                    <p className="ibg-small">{t("titrePage.FocusIA.description")}</p>
                                    <div className="ibg-chips">
                                        {suggestions.map((s) => <button key={s} onClick={() => setUserMessage(s)}>{s}</button>)}
                                    </div>
                                </div>}
                            <MessageList
                                className="message-list"
                                lockable={true}
                                toBottomHeight={'100%'}
                                dataSource={messages}
                                messageBoxStyles={{ textAlign: "left", background: 'none', borderRadius: "10px", boxShadow: "none", overflow: "visible", maxWidth: "90%" }}
                                notchStyle={{ visibility: "hidden" }}
                                sendMessagePreview
                                referance={React.createRef()}
                            />
                        </div>
                        {loading ? <div className="ibg-assistant__loading"><Riple color="#4F6BED" size="small" text="" textColor="" /></div> : ""}
                        {alertError ? <Alert severity="error" sx={{ mx: 2, borderRadius: 3 }}>
                            {t("errorSpeech")}
                        </Alert>
                            :
                            ""}
                        {alertErrorSpeech ? <Alert severity="error" sx={{ mx: 2, borderRadius: 3 }}>
                            {t("errorSpeech2")}
                        </Alert>
                            :
                            ""}
                        <Form className="ibg-composer-form" onFinish={handleSendMessage}>
                            {/* <input placeholder={t("placeholderMail")} className='inp' type="text" />
                            <button className='btn'>{t("souscrire")}</button> */}
                            <div className="ibg-composer">
                                <IconButton aria-label="micro" onClick={() => {
                                    if (!browserSupportsSpeechRecognition) {
                                        setAlertError(true)

                                        setTimeout(() => {
                                            setAlertError(false)
                                        }, 3000);
                                    }
                                    SpeechRecognition.startListening()
                                }} className={listening ? 'is-listening' : ''}><Mic fontSize="small" /></IconButton>
                                <textarea
                                    rows={1}
                                    value={userMessage}
                                    onKeyDown={(e) => {
                                        if (e.which === 13) {
                                            handleSendMessage()
                                        }
                                    }}
                                    onChange={(e) => {
                                        if (e.target.value !== '\n') {
                                            setUserMessage(e.target.value)
                                        }
                                    }}
                                    placeholder={t("placeholderChat")}
                                    onSubmit={handleSendMessage}
                                />
                                {lecture ? <IconButton aria-label="stop" onClick={() => { window.speechSynthesis.cancel(); setLecture(false) }}><VoiceOverOff fontSize="small" /></IconButton> : ""}
                                {!lecture ? <IconButton aria-label="lecture" disabled={messages.length === 0} onClick={handleSpeechMessage}><RecordVoiceOver fontSize="small" /></IconButton> : ""}
                                <button type="button" className="ibg-composer__send" aria-label="send" disabled={userMessage.trim() === "" || loading} onClick={handleSendMessage}><SendRounded fontSize="small" /></button>
                            </div>

                            {/* <button className='btn' onClick={handleSendMessage} disabled={loading}>
                                {loading ? "Envoi en cours..." : "Envoyer"}
                            </button> */}
                        </Form>
                    </div>
                    <p className="ibg-assistant__foot">{t("footerChat")}</p>
                </Container>
            </section>
            <Footer />
        </div>
    )
}

export default FocusIA
